module.exports = __webpack_public_path__ + "img/x-symbol.255281ea.svg";